import { ApiKeyApiModel } from '../../../api/users/models/api-key.api.model';

export class ApiKey {
    id: number;
    keyValue: string;
    name: string;
    note: string;
    createdBy: string;
    createdDate: Date;
    disabled: boolean;

    constructor(apiModel?: ApiKeyApiModel) {
        if (apiModel) {
            this.id = apiModel.apiKeyId;
            this.keyValue = apiModel.apiKey;
            this.name = apiModel.name ?? '';
            this.note = apiModel.note ?? '';
            this.createdBy = apiModel.createdByUsername;
            this.createdDate = new Date(apiModel.createdDate);
            this.disabled = apiModel.disabled;
        } else {
            this.id = NaN;
            this.keyValue = '';
            this.name = '';
            this.note = '';
            this.createdBy = '';
            this.createdDate = new Date();
            this.disabled = false;
        }
    }

    clone(): ApiKey {
        const clone = new ApiKey();
        clone.id = this.id;
        clone.keyValue = this.keyValue;
        clone.name = this.name;
        clone.note = this.note;
        clone.createdBy = this.createdBy;
        clone.createdDate = this.createdDate;
        clone.disabled = this.disabled;
        return clone;
    }
}
